import React, { useMemo } from 'react';

import PrivacyFilter from 'src/components/privacy-filter';
import { FILTER_KIND } from 'src/components/privacy-filter/constants';
import SearchField from 'src/components/search-field';
import { useIntl } from 'src/hooks/intl';
import { Filter, FilterGroup } from 'src/sections/repository/styles/filters';
import { FilterContainer } from 'src/sections/workspace/sections/pullrequests/styles/filter';

import messages from '../projects.i18n';

type WorkspaceProjectsFilterProps = {
  onChangeIsPrivate: (isPrivate: string | undefined) => void;
  onChangeSearch: (query: string) => void;
  isPrivate: string | undefined;
  search: string | undefined;
};

const WorkspaceProjectsFilter = (props: WorkspaceProjectsFilterProps) => {
  const intl = useIntl();

  const { isPrivate, onChangeIsPrivate, search, onChangeSearch } = props;

  const handleIsPrivateChange = (privacyFilter: {
    privacy: FILTER_KIND.PRIVATE | FILTER_KIND.PUBLIC;
  }) => {
    let filter;
    switch (privacyFilter.privacy) {
      case FILTER_KIND.PRIVATE:
        filter = 'true';
        break;
      case FILTER_KIND.PUBLIC:
        filter = 'false';
        break;
      default:
        filter = undefined;
    }
    onChangeIsPrivate(filter);
  };

  const privacy = useMemo(() => {
    return isPrivate
      ? isPrivate === 'true'
        ? FILTER_KIND.PRIVATE
        : FILTER_KIND.PUBLIC
      : undefined;
  }, [isPrivate]);

  const handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
    onChangeSearch(e.currentTarget.value);
  };
  const clearSearchFilter = () => {
    onChangeSearch('');
  };

  return (
    <FilterContainer>
      <FilterGroup>
        <SearchField
          currentSearch={search}
          handleFilterChange={handleSearchChange}
          placeholder={intl.formatMessage(
            messages.projectSearchFilterPlaceholder
          )}
          clearFilter={clearSearchFilter}
          fieldName="search-projects-table-input"
        />
        <Filter mobileOrder={1} isFirstFilterElement>
          <PrivacyFilter
            onFilterChange={handleIsPrivateChange}
            privacy={privacy}
          />
        </Filter>
      </FilterGroup>
    </FilterContainer>
  );
};

export default WorkspaceProjectsFilter;
